import "./App.css";
import Sidebar from "./component/sidebar/Sidebar";
import Home from "./component/Home/Home";
import Profile from "./component/Profile/Profile";
import Skills from "./component/Skills/Skills";
import Resume from "./component/Resume/Resume";
import Contact from "./component/Contact/Contact";
import Services from "./component/Services/Services";
import Error from "./Error";
import Facts from "./component/Facts/Facts";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Sidebar></Sidebar>,
    errorElement:<Error></Error>,
    children: [
      { path: "/", element: <Home></Home> },
      { path: "/about", element: <Profile></Profile> },
      { path: "/skills", element: <Skills></Skills> },
      { path: "/services", element: <Services></Services> },
      { path: "/resume", element: <Resume></Resume> },
      { path: "/contact", element: <Contact></Contact> }
      
    ],
     
  },
  // {
  //   path: "*", element: <Error></Error>
  // }
]);
function App() {
  return (
    <div className="App">
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
